

























import { Component, Vue, Prop } from 'vue-property-decorator'

import RoundAvatar from '@/components/RoundAvatar.vue'

import Customer from '@/models/customer'

@Component({
  components: {
    RoundAvatar,
  },
})
export default class InlineCustomerWidget extends Vue {
  @Prop() customer!: Customer
}
